import React from "react";
import { Index } from "../components/AboutUs/Index";

export const AboutUs = () => {
  return <Index />;
};
